/**
 * IMPORTS
 */
import {gql} from '@apollo/client';
import {ISubscription} from 'src/services/graphis/index.d';


/**
 * TYPES
 */
import {ICustomerTagAddedArgs}
    from 'src/aggregates/customers/subscriptions/index.d';
import {ICustomerTagRemovedArgs}
    from 'src/aggregates/customers/subscriptions/index.d';


/**
 * EXPORTS
 */

/**
 * I am a subscription to receive added customer-tag.
 */
export const CUSTOMER_TAG_ADDED: ISubscription<
    ICustomerTagAddedArgs
> = {
    getTopic: ({tag}) => `customer_tag_added_${tag}`,
    query: gql`
        subscription customerTagAdded ($tag: Int!) {
            customerTagAdded (tag: $tag) {
                customer
                customerTag
                tag
            }
        }
    `,
};


/**
 * I am a subscription to receive removed customer-tag.
 */
export const CUSTOMER_TAG_REMOVED: ISubscription<
    ICustomerTagRemovedArgs
> = {
    getTopic: ({tag}) => `customer_tag_removed_${tag}`,
    query: gql`
        subscription customerTagRemoved ($tag: Int!) {
            customerTagRemoved (tag: $tag) {
                customer
                customerTag
                tag
            }
        }
    `,
};
